import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { ActivationAlertsContractSocialMediaChannel } from "@similarweb/pro-api-client";

import type { ValueMap } from "../../filters/types";

export const ALL_CHANNELS: ActivationAlertsContractSocialMediaChannel[] = [
    "Facebook",
    "Instagram",
    "LinkedIn",
    "TikTok",
    "YouTube",
];

interface ISocialAlertsFilterState {
    selectedChannels: ValueMap<ActivationAlertsContractSocialMediaChannel>;
    isDefaultChannelsSelected: boolean;
}

interface ISocialAlertsFilterStore extends ISocialAlertsFilterState {
    reset: () => void;
    setSelectedChannels: (channels: ValueMap<ActivationAlertsContractSocialMediaChannel>) => void;
}

const initialState: ISocialAlertsFilterState = {
    selectedChannels: new Map(),
    isDefaultChannelsSelected: true,
};

export const useSocialAlertsFilterStore = create<ISocialAlertsFilterStore>()(
    devtools(
        (set) => ({
            ...initialState,
            reset: () => set(initialState),
            setSelectedChannels: (channels) =>
                set({
                    selectedChannels: channels,
                    isDefaultChannelsSelected: channels.size === ALL_CHANNELS.length || !channels.size,
                }),
        }),
        { name: "SocialAlertsFilterStore" },
    ),
);
